const productsData: {
  name: string;
  value: string;
  desc: string;
  icon?: string;
  img?: string;
}[] = [
  {
    name: "数字员工企业版",
    value: "aiBeings",
    desc: "基于AI多模态引擎打造数字员工与数字专家生产线，已覆盖从极速复刻到高端定制全链路，支持爆款文案、智能成片及一键分发，为构建IP营销矩阵提效降本。",
  },
  {
    name: "数字员工直播平台",
    value: "live",
    desc: "数字员工赋能电商直播：基于商品列表一键生成直播间，60秒内完成视觉搭建、直播脚本及互动话术，无缝对接多平台支持无人值守，低成本高效能开拓全域增长。",
  },
  {
    name: "智能交互一体机",
    value: "machine",
    desc: "融合多模态数字人、大模型交互与高清屏显的智能终端，可轻松链接 “看得见、听得懂、会互动” 的数字员工，以直观触控与多模态互动，解锁人机交互新体验。",
  },
  {
    name: "易企聊",
    value: "yiqiliao",
    desc: "AI驱动的智能营销窗口：以AI数字人与大模型对话重构品牌展示与客户运营，支持企业号/员工号双矩阵建设，7×24小时多语言智能接待客户，助力B2C与B2B高效获客与转化。",
  },
  {
    name: "企业智能体平台",
    value: "agentx",
    desc: "以 “开箱即用+零代码” 模式，预置多场景智能体矩阵，支持可视化工作流编排，联动企业知识库，打通数据孤岛，快速集成业务系统，助力企业智能化转型。",
  },
  {
    name: "AI互动营销平台",
    value: "aiMarketing",
    desc: "轻量级AI营销员工，助力B端客户跨平台营销获客，链接抖音、小红书、视频号等主流新媒体平台，为线索获取、成交转化、粉丝活跃三大核心环节提效赋能。",
  },
  {
    name: "交互式IP解决方案",
    value: "interactiveIP",
    desc: "拥有《喜羊羊与灰太狼》《超级飞侠》等知名IP矩阵，提供交互式IP授权、AI创意营销及软硬件方案，从品牌联名到IP场景植入，助力企业一站式释放IP商业价值。",
  },
  {
    name: "必搜-GEO搜索产品",
    value: "geo",
    desc: "为企业提供一站式GEO推广服务，树立起您的巨大广告牌，让用户主动找到您！小冰科技深耕AI十载洞悉大模型底层逻辑，精准驾驭流量运行规律。",
  },
];
const getProducts = () => {
  const products = [...productsData];
  products.forEach((product, index) => {
    const img = new URL(
      `../assets/productImgs/${product.value}.png`,
      import.meta.url
    ).href;
    const icon = new URL(
      `../assets/productIcons/${product.value}_icon.png`,
      import.meta.url
    ).href;
    product.img = img;
    product.icon = icon;
  });
  return products;
};
export { getProducts, productsData };
